import api from '@/lib/api';

/**
 * Day 8 — Review Outcomes Explorer API client.
 * Read-only endpoint; no writes.
 */
export async function listReviewOutcomes(params = {}) {
  const clean = {};
  for (const [k, v] of Object.entries(params)) {
    if (v !== undefined && v !== null && v !== '') clean[k] = v;
  }
  const res = await api.get('/participants/charts/review-outcomes', { params: clean });
  return res.data?.data || { items: [], total: 0, limit: 25, offset: 0 };
}
